import React from "react";
import Slider from "react-slick";

export class SpeciesScoresColTv extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      boatScores: [],
      logs: this.props.logs,
      classLogs: [],
      boatClass: this.props.boatClass,
      speciesId: this.props.speciesId,
      speciesName: this.props.speciesName,
    }
  }
  
  componentWillReceiveProps(newProps) {
    this.setState({logs: newProps.logs, speciesId: newProps.speciesId, speciesName: newProps.speciesName, boatClass: newProps.boatClass});
    if(newProps.boatClass) {
			this.classFilter(newProps.logs);
		} else {
			this.getSpeciesPoints(newProps.speciesId, newProps.logs)
		}
  }
    
  classFilter(logs) {
      var classLogs = [];
      logs.forEach((boat) => {
          if(boat.boatClass === this.state.boatClass) {
              classLogs.push({
                  id: boat.id,
                  boatClass: boat.boatClass,
                  boatName: boat.boatName,
                  boatThm: boat.boatThm,
                  boatCaughtFish:boat.boatCaughtFish,
                  lastFishTime: boat.lastFishTime,
                  total: boat.total
              });
          }
      })
    this.getSpeciesPoints(this.state.speciesId, classLogs)
  }
    
  getLastFishTime(times){
      var timesArray = [];
      times.forEach((time) => {
          if(time.speciesTimes){
              time.speciesTimes.forEach((t) => {
                  var secs = new Date(t).getTime() / 1000;
                  timesArray.push(secs);
              })
          }
      })
      timesArray.sort((a, b) => b - a);
      
      return timesArray;
  }

  getSpeciesPoints(speciesId, classLogs) {
    var boatTotals = [];
    classLogs.forEach((boatLog) => {
      var totalPoints = 0;
      var speciesCount = 0;
      var lastF = [];
      boatLog.boatCaughtFish.forEach((log) => {
        if(speciesId === log.speciesId && log.lbs > 0) {
          totalPoints = totalPoints + parseFloat(log.lbs);
        }
        if(speciesId === log.speciesId) {
          speciesCount++
          lastF.push(new Date(log.catchDate).getTime())
        }
      });
      var points = parseFloat(totalPoints.toFixed(2));
      if(points > 0){
        var d = new Date(boatLog.lastFishTime);
        boatTotals.push({
          id: boatLog.boatId,
          boatName: boatLog.boatName,
          boatThm: boatLog.boatThm,
          total: points,
          lastFishTime: boatLog.lastFishTime,
          lastSpeceiesFishTime: this.getLastFishTime(lastF),
          lastTime: parseInt(Math.round(d.getTime() / 1000))
        })
      }
    })
    this.scoreSortFilter(boatTotals);
  }

  scoreSortFilter(boatTotals) {
    Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    if(boatTotals && boatTotals.length >= 1) {
      boatTotals.sortOn("total", "lastSpeceiesFishTime");
      boatTotals.reverse();
    }
  
    function isNumber(obj) {
      return obj!== undefined && typeof(obj) === 'number' && !isNaN(obj);
    }

    function filterByTotal(item) {
      if (isNumber(item.total)) {
        return true;
      } 
      return false; 
    }
      var boatScoresArray = boatTotals.filter(filterByTotal);
      var rank = 1;
      var bScores = [];
      boatScoresArray.forEach((boat) => {
        bScores.push({
          rank: rank++,
          boat: boat
        })
      })
      if(bScores.length > 0) {
          this.setState({
            boatScores: bScores,
          })
      } else {
          this.setState({
            boatScores: [],
          })
      }
  }
  
  render() {
    const topFour = this.state.boatScores.slice(0,3);
    const settings = {
      dots: false,
      arrows: false,
      infinite: false,
      slidesToShow: topFour,
      vertical: true,
    };
    return (
        <div className="speciesScoresCol-boxTv-full">
            <div className="species_box_title_tv">{ this.state.speciesName } Division</div>
          {this.state.boatScores.length > 0 ? this.state.boatScores.map(boat => (
            <div id='rank-box' className="boatBox" style={{width: '90%', margin: 10, padding: 5}} key={boat.rank}>
                <div className='boatTotalRow'>
                  <div className='boatTotalRank'># {boat.rank}</div>
                  <div className='boatTotalName'>{boat.boat.boatName}</div>
                  <div className='boatTotalTotal'>{boat.boat.total} Pts</div>
                </div>
            </div>
          )) : <div style={{color: '#000', fontSize: 30}}>No { this.state.speciesName } logged yet.</div>}
    </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/tournaments/pescadora/comps/SpeciesScoresColTv.js